import { Item } from '../elements/partials/table/models/table.models'

export const getStatusLabel = (item: Item): string => {
  if (item.isWarningHighlight) return 'PENDING'
  if (item.isDisabledHighlight) return 'REJECTED'
  if (item.isInfoHighlight) return 'DRAFT'
  if (item.isSuccessHighlight) {
    if (item.status === 'unchanged') return 'UNCHANGED'
    return 'PUBLISHED'
  }
  if (item.editorialStatus === 'Published' || item.status === 'Published')
    return 'PUBLISHED'
  if (item.isDangerHighlight) return 'TBC'
  return ''
}

export const getStatusClass = (item: Item): string => {
  if (item.isWarningHighlight) return 'status-pending'
  if (item.isDisabledHighlight) return 'status-rejected'
  if (item.isInfoHighlight) return 'status-draft'
  if (item.isSuccessHighlight) return 'status-published'
  if (item.editorialStatus === 'Published' || item.status === 'Published')
    return 'status-published'
  if (item.isDangerHighlight) return 'status-danger'
  return ''
}
